
import React from 'react';
import { UploadForm } from './UploadForm';
import { UploadInstructions } from './UploadInstructions';
import { UploadSummaryReport } from '../UploadSummaryReport';
import { useUploadProcessor } from './useUploadProcessor';
import { BulkUploadGuardsProps } from './types';

export const BulkUploadGuards = ({ onSuccess, onClose, onComplete }: BulkUploadGuardsProps) => {
  const {
    isUploading,
    progress,
    showReport,
    stats,
    handleFileUpload,
    resetStats
  } = useUploadProcessor(onSuccess);

  const handleCloseWithReport = () => {
    resetStats();
    onClose();
    if (onComplete) {
      onComplete();
    }
  };

  // If showing report, render the report component
  if (showReport) {
    return (
      <UploadSummaryReport 
        stats={stats} 
        onClose={handleCloseWithReport} 
      />
    );
  }

  return (
    <div className="space-y-4 p-4">
      <UploadForm 
        isUploading={isUploading}
        progress={progress} 
        stats={stats}
        onFileChange={handleFileUpload}
      />
      
      <UploadInstructions />
    </div>
  );
};
